module.exports = __webpack_public_path__ + "501faa145ea2e83e779c54cc43eba545.pdf";